<template>
    <b-card header-tag="header" footer-tag="footer" class="mt-8">
        <template v-slot:header>
            <div class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center">
                <div>
                    <p class="mb-2 mb-sm-0" style="font-size: 21px">Lista de pedidos del vendedor: {{ sellerInfo.nombre }} </p>
                    <template v-if="filterInfo.dateFrom && filterInfo.dateTo">
                        Pedidos realizados entre: {{ filterInfo.dateFrom }} - {{ filterInfo.dateTo }}
                    </template>
                    <template v-else-if="filterInfo.dateTo">
                        Pedidos Hasta: {{ filterInfo.dateTo }}
                    </template>
                </div> 
                <button class="btn btn-danger mt-2 mt-sm-0" @click.prevent="$emit('clear-orders-user-range-list')">Cerrar</button>
            </div>
        </template>
        <b-card-text>
            <b-table 
                responsive
                :fields="fields" 
                striped hover 
                :items="sellerOrders">
                <template v-slot:cell(nombre_cliente)="data">
                    {{ data.item.nombre_cliente }}
                </template>
                <template v-slot:cell(correo_cliente)="data">
                    {{ data.item.correo_cliente }}
                </template>
                <template v-slot:cell(telefono_cliente)="data">
                    {{ data.item.telefono_cliente }}
                </template>
                <template v-slot:cell(created_at)="data">
                    {{ data.item.created_at }}
                </template>
                <template v-slot:cell(total_precio)="data">
                    $ {{numberFormat(data.item.total_precio) }} COP
                </template>
                <template v-slot:cell(commission_percentage_on_sales)="data">
                    {{ data.item.commission_percentage_on_sales }}
                </template>
                <template v-slot:cell(total_commission_on_sales)="data">
                  $ {{ numberFormat(data.item.total_commission_on_sales) }} COP
                </template>
                <template v-slot:cell(actions)="{ item }">
                    <b-button size="sm" variant="info" v-b-tooltip.hover title="Ver" class="text-white" 
                    :to="{name: 'InfoPedido', params:{ id: item.id}}">
                        <b-icon icon="search"></b-icon>
                    </b-button>
                </template>
            </b-table>
            <template v-if="sellerOrders.length < 1">
                <b-alert show variant="danger">
                    Lo sentimos, no se han encontrado resultados para su busqueda.
                </b-alert>
            </template>
        </b-card-text>
        <template v-slot:footer>
            <div class="mt-3">
                <b-row>                            
                    <b-col cols="12" md="4">
                        <b-pagination 
                            size="md" 
                            pills 
                            :total-rows="paginator.totalPage" 
                            v-model="paginator.page" 
                            :per-page="1" 
                            @input="changePage" 
                            first-number 
                            last-number>
                        </b-pagination>
                    </b-col>
                    <b-col cols="12" sm="2">
                        <b-form-select @change="updatePageSize()" v-model="paginator.pageSize" :options="pageSize" ></b-form-select>
                    </b-col>
                </b-row>
            </div>
        </template>
    </b-card>
</template>

<script>
export default {
    name: "SalesCommissionTrackerOdersUserTable",
    props: {
        sellerOrders: {
            type: Array
        },
        sellerInfo: {
            type: Object
        },
        paginator: {
            type: Object
        },
        pageSize: {
            type: Array
        },
        filterInfo:{
            type: Object
        }
    },
    data(){
        return{
            fields: [
                { key: 'nombre_cliente', label: 'Nombre Cliente', sortable: true},
                { key: 'correo_cliente', label: 'Correo electronico Cliente', sortable: true},
                { key: 'telefono_cliente', label: 'Telefono Cliente'},
                { key: 'created_at', label: 'Realizado el', sortable: true},
                { key: 'total_precio', label: 'Precio Total', sortable: true},
                { key: 'commission_percentage_on_sales', label: '% Comisión de venta', sortable: true},
                { key: 'total_commission_on_sales', label: 'Comisión de venta', sortable: true},
                { key: 'actions', label: 'Acciones'},
            ],
        }
    },
    methods: {
        updatePageSize(){
            this.paginator.page = 1;
            this.$emit('get-seller-orders-list', this.sellerInfo);
        },
        changePage(){
            this.$emit('change-page', this.paginator.page, this.sellerInfo);
        }
    }
};

</script>
<style scoped>

</style>